import React from "react";
import { match, P } from "ts-pattern";
import * as styles from "./WrapWithLink.module.scss";
import clsx from "clsx";
import { CardAction } from "./Card/cardAction";

type LinkAction = {
  href: string | undefined;
  target?: string;
  rel?: string;
  onClick?: never;
} & Omit<
  React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  >,
  "onClick" | "href"
>;

type ButtonAction = {
  href?: never;
  rel?: string;
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

type NoAction = {
  href?: never;
  onClick?: never;
};

type Action = LinkAction | ButtonAction | NoAction;

export const WrapWithLink: React.FC<
  React.PropsWithChildren<
    Action & {
      "data-content-piece": string;
    }
  >
> = ({ children, ...props }) => {
  return match(props)
    .with({ href: P.string }, (props) => <a {...props}>{children}</a>)
    .with({ href: P.optional(P.nullish), onClick: P.nonNullable }, (props) => (
      <button {...props} className={clsx(styles.button, props.className)}>
        {children}
      </button>
    ))
    .otherwise(() => <React.Fragment>{children}</React.Fragment>);
};

export const actionFromCardAction = (
  action: CardAction | undefined
): Action | undefined => {
  return match(action)
    .with({ href: P.string }, (props) => ({
      href: props.href,
      rel: props.rel,
      target: props.openInNewTab ? "_blank" : undefined
    }))
    .with({ onClick: P.nonNullable }, (props) => ({ onClick: props.onClick }))
    .with(P.nullish, () => undefined)
    .with({ button: P.nonNullable }, () => undefined)
    .exhaustive();
};
